import jwtDecode from 'jwt-decode'

export default async function ({ store, redirect, app, route }) {
  // Use route.query instead of direct DOM access
  const params = route.query ? '?' + new URLSearchParams(route.query).toString() : ''

  // Check if session cookie exists
  if (!app.$cookies || !app.$cookies.get('__session')) {
    app.$cookies.remove('__session')
    store.commit("setCurrentUser", null)
    return redirect('/login' + params)
  }

  try {
    const token = app.$cookies.get('__session')
    const decodedToken = jwtDecode(token)

    // Validate token expiration
    const currentTime = Math.floor(Date.now() / 1000)
    if (decodedToken.exp && decodedToken.exp < currentTime) {
      console.warn('Token expired, redirecting to login')
      app.$cookies.remove('__session')
      store.commit("setCurrentUser", null)
      return redirect('/login' + params)
    }

    // Validate required token fields
    if (!decodedToken.user_id || !decodedToken.email) {
      console.error('Invalid token structure')
      app.$cookies.remove('__session')
      store.commit("setCurrentUser", null)
      return redirect('/login' + params)
    }

    const uid = decodedToken.user_id
    const email = decodedToken.email

    store.commit("setCurrentUser", { email, uid, redirect })

    // Fetch user profile
    await store.dispatch('fetchUserProfile')

    if (!store.state.userProfile) {
      console.warn('User profile not found')
      return redirect('/login' + params)
    }
  } catch (error) {
    // Handle JWT decode errors
    console.error('Authentication error:', error.message)
    app.$cookies.remove('__session')
    store.commit("setCurrentUser", null)
    return redirect('/login' + params)
  }

  // Final validation
  if (!store || !store.state || !store.state.currentUser || !store.state.userProfile) {
    return redirect('/login' + params)
  }

  // Redirect from index to home
  if (route.name === 'index') {
    return app.$util.gotoHOME()
  }
}

